var _path, _g, _g2, _path2, _path3, _g3, _g4, _path4, _path5, _g5, _g6, _path6, _path7, _g7, _g8, _g9, _path8, _path9, _path0, _g0, _g1, _circle, _circle2, _g10, _path1, _g11, _g12, _g13, _path10, _circle3, _circle4, _g14, _path11, _circle5, _circle6, _g15, _path12, _circle7, _circle8, _g16, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLogoDevelopers = function SvgLogoDevelopers(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 120",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "logo-developers_svg__mask0_10099_8268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 35,
    height: 76
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9922 73.1134C35.5586 74.848 33.5229 75.2214 32.5592 75.1913L33.0109 13.1717L1.02991 1.87892C1.96946 0.830956 3.53771 0.254774 4.55324 0.523837C5.56876 0.7929 33.0109 9.42247 33.0109 9.42247C35.9922 10.326 36.0223 12.6748 35.9922 13.7589V73.1134Z",
    fill: "#2D1919"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-developers_svg__mask0_10099_8268)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter0_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.09314 1.60795L3.966 -0.966797L21.673 4.58923L18.24 8.2029L-1.09314 1.60795Z",
    fill: "url(#logo-developers_svg__paint0_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter1_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8132 6.84769L18.8724 4.27295L36.5794 9.82897L33.1464 13.4426L13.8132 6.84769Z",
    fill: "url(#logo-developers_svg__paint1_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter2_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4813 9.8291H37.7087V77.1338H30.4813V9.8291Z",
    fill: "url(#logo-developers_svg__paint2_linear_10099_8268)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter3_i_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00305176 3.81367C-0.00305176 2.10886 1.64901 0.892185 3.27704 1.398L32.0946 10.3513C33.7572 10.8679 34.8902 12.4063 34.8902 14.1474V73.0516C34.8902 74.5886 33.3352 75.6376 31.91 75.062L1.80522 62.9027C0.712408 62.4613 -0.00305176 61.4008 -0.00305176 60.2222V3.81367Z",
    fill: "url(#logo-developers_svg__paint3_linear_10099_8268)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0.312988 4.71699C0.312988 3.01218 1.96505 1.79551 3.59308 2.30132L31.4848 10.967C32.6783 11.3378 32.8997 12.987 31.8692 13.6942C28.0596 16.3085 20.801 21.7403 13.8586 29.4332C5.92624 38.2232 0.312988 61.9563 0.312988 61.9563V4.71699Z",
    fill: "url(#logo-developers_svg__paint4_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-developers_svg__mask1_10099_8268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 17,
    width: 20,
    height: 41
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0006 56.1878C68.7717 57.1033 67.6973 57.3004 67.1887 57.2845L67.4271 24.5518L50.5482 18.5917C51.0441 18.0386 51.8718 17.7345 52.4078 17.8765C52.9437 18.0185 67.4271 22.5731 67.4271 22.5731C69.0006 23.0499 69.0165 24.2895 69.0006 24.8617V56.1878Z",
    fill: "#2D1919"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-developers_svg__mask1_10099_8268)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter4_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4277 18.4487L52.0978 17.0898L61.4432 20.0222L59.6314 21.9294L49.4277 18.4487Z",
    fill: "url(#logo-developers_svg__paint5_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter5_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.295 21.2144L59.9652 19.8555L69.3105 22.7878L67.4987 24.695L57.295 21.2144Z",
    fill: "url(#logo-developers_svg__paint6_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter6_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.092 22.7876H69.9065V58.3096H66.092V22.7876Z",
    fill: "url(#logo-developers_svg__paint7_linear_10099_8268)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter7_i_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0031 19.6126C50.0031 18.7128 50.875 18.0707 51.7342 18.3377L66.9435 23.0631C67.821 23.3357 68.419 24.1476 68.419 25.0665V56.1549C68.419 56.9661 67.5983 57.5198 66.8461 57.216L50.9574 50.7986C50.3807 50.5656 50.0031 50.0059 50.0031 49.3838V19.6126Z",
    fill: "url(#logo-developers_svg__paint8_linear_10099_8268)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M50.1698 20.0892C50.1698 19.1894 51.0417 18.5473 51.901 18.8142L66.6216 23.3878C67.2515 23.5835 67.3684 24.4539 66.8245 24.8271C64.8139 26.2069 60.983 29.0737 57.3189 33.1339C53.1324 37.773 50.1698 50.2989 50.1698 50.2989V20.0892Z",
    fill: "url(#logo-developers_svg__paint9_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-developers_svg__mask2_10099_8268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 60,
    width: 16,
    height: 32
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6479 90.9481C66.4649 91.6801 65.6058 91.8377 65.1991 91.825L65.3898 65.6516L51.8932 60.8858C52.2897 60.4435 52.9515 60.2004 53.3801 60.3139C53.8087 60.4275 65.3898 64.0693 65.3898 64.0693C66.6479 64.4506 66.6606 65.4418 66.6479 65.8993V90.9481Z",
    fill: "#2D1919"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-developers_svg__mask2_10099_8268)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter8_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9972 60.7716L53.1322 59.6851L60.6049 62.0298L59.1561 63.5548L50.9972 60.7716Z",
    fill: "url(#logo-developers_svg__paint10_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter9_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2881 62.9826L59.4231 61.896L66.8958 64.2407L65.447 65.7658L57.2881 62.9826Z",
    fill: "url(#logo-developers_svg__paint11_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter10_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3223 64.2407H67.3723V92.6445H64.3223V64.2407Z",
    fill: "url(#logo-developers_svg__paint12_linear_10099_8268)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter11_i_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4574 62.0657C51.4574 61.166 52.3293 60.5238 53.1886 60.7908L64.7075 64.3696C65.585 64.6423 66.183 65.4542 66.183 66.3731V90.5822C66.183 91.3934 65.3623 91.9471 64.6101 91.6433L52.4118 86.7164C51.835 86.4834 51.4574 85.9237 51.4574 85.3016V62.0657Z",
    fill: "url(#logo-developers_svg__paint13_linear_10099_8268)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M51.5907 62.4471C51.5907 61.5473 52.4626 60.9052 53.3219 61.1721L64.419 64.6199C65.049 64.8156 65.1667 65.6895 64.6262 66.0676C62.9596 67.2338 60.0739 69.4487 57.3072 72.5145C53.9596 76.224 51.5907 86.2399 51.5907 86.2399V62.4471Z",
    fill: "url(#logo-developers_svg__paint14_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-developers_svg__mask3_10099_8268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 13,
    width: 49,
    height: 105
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4967 114.26C58.8967 116.66 56.08 117.177 54.7467 117.135L55.3717 31.3226L11.1217 15.6975C12.4217 14.2475 14.5916 13.4502 15.9967 13.8225C17.4018 14.1948 55.3717 26.135 55.3717 26.135C59.4967 27.3851 59.5384 30.635 59.4967 32.135V114.26Z",
    fill: "#2D1919"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-developers_svg__mask3_10099_8268)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter12_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1842 15.3223L15.1842 11.7598L39.6842 19.4473L34.9342 24.4473L8.1842 15.3223Z",
    fill: "url(#logo-developers_svg__paint15_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter13_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8092 22.5723L35.8092 19.0098L60.3092 26.6973L55.5592 31.6973L28.8092 22.5723Z",
    fill: "url(#logo-developers_svg__paint16_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter14_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8717 26.6973H61.8717V119.822H51.8717V26.6973Z",
    fill: "url(#logo-developers_svg__paint17_linear_10099_8268)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter15_i_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69226 18.374C9.69226 16.0152 11.9781 14.3318 14.2307 15.0316L54.1037 27.4198C56.4041 28.1345 57.9718 30.2632 57.9718 32.6721V114.174C57.9718 116.301 55.8202 117.752 53.8483 116.956L12.1942 100.132C10.6822 99.5209 9.69226 98.0535 9.69226 96.4227V18.374Z",
    fill: "url(#logo-developers_svg__paint18_linear_10099_8268)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter16_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1674 56.3989C22.1674 54.0401 24.4532 52.3567 26.7058 53.0565L44.5892 58.6127C46.8897 59.3275 48.4573 61.4561 48.4573 63.8651V104.375C48.4573 106.502 46.3057 107.953 44.3338 107.157L24.6693 99.2146C23.1573 98.6039 22.1674 97.1364 22.1674 95.5057V56.3989Z",
    fill: "url(#logo-developers_svg__paint19_linear_10099_8268)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3124 49.8094C35.3124 46.5668 38.6932 44.4322 41.6208 45.8263C44.1813 47.0456 45.8124 49.6288 45.8124 52.4648V87.2477C45.8124 89.9508 42.9941 91.7302 40.5536 90.5681C37.3519 89.0434 35.3124 85.8134 35.3124 82.2671V49.8094Z",
    fill: "#382395"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6936 45.1787C38.3114 45.8977 37.3124 47.333 37.3124 49.0957V82.5534C37.3124 85.9939 39.2321 89.1369 42.2705 90.7135C41.7044 90.7349 41.1189 90.6235 40.5536 90.3544C37.3519 88.8297 35.3124 85.5996 35.3124 82.0534V49.5957C35.3124 47.0554 37.3872 45.1951 39.6936 45.1787Z",
    fill: "url(#logo-developers_svg__paint20_linear_10099_8268)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9999 57.041L45.8124 52.541V58.041L37.9999 62.541V57.041Z",
    fill: "url(#logo-developers_svg__paint21_linear_10099_8268)"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    filter: "url(#logo-developers_svg__filter17_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9301,
    cy: 58.4366,
    rx: 2.70841,
    ry: 3.61176,
    transform: "rotate(-19.5953 40.9301 58.4366)",
    fill: "black"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    filter: "url(#logo-developers_svg__filter18_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.0363,
    cy: 64.4771,
    rx: 6.43187,
    ry: 6.83368,
    transform: "rotate(-19.5953 33.0363 64.4771)",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6381,
    cy: 61.431,
    r: 6.3587,
    fill: "url(#logo-developers_svg__paint22_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-developers_svg__mask4_10099_8268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 55,
    width: 13,
    height: 13
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6379,
    cy: 61.431,
    r: 6.3587,
    fill: "url(#logo-developers_svg__paint23_linear_10099_8268)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-developers_svg__mask4_10099_8268)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter19_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1174 63.9054C38.0118 66.0439 38.265 59.3701 36.2792 57.4148C34.2933 55.4595 30.8205 58.9632 32.926 56.8247C35.0316 54.6862 38.3484 54.5377 40.3342 56.493C42.32 58.4483 42.2229 61.7669 40.1174 63.9054Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter20_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6421 57.6236C42.1721 59.969 34.9298 59.4397 33.0211 61.4987C31.1123 63.5576 35.2598 67.4252 32.7298 65.0798C30.1998 62.7344 29.6962 59.1639 31.6049 57.1049C33.5137 55.0459 37.1121 55.2781 39.6421 57.6236Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter21_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2802 64.7964C30.4429 63.5619 34.1125 66.11 36.5497 66.4312C38.9869 66.7523 39.2688 64.7249 39.1061 65.9594C38.9434 67.194 36.8358 67.9345 34.3986 67.6133C31.9614 67.2922 30.1175 66.031 30.2802 64.7964Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter22_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2876 63.1816C38.9462 66.5115 36.6048 60.7404 34.8079 60.5561C33.0111 60.3719 32.4394 65.8444 32.7807 62.5146C33.1221 59.1847 34.8554 56.6347 36.6522 56.8189C38.4491 57.0031 39.6289 59.8518 39.2876 63.1816Z",
    fill: "#91EEFF"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3383 55.6137C34.2654 55.3445 30.0979 56.27 30.0109 62.1263C30.4063 60.1627 32.2252 56.1111 36.3383 55.6137Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter23_dddd_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9967 33.5723V86.8223",
    stroke: "#413AC5",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter24_d_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9967 60.5723V88.8223",
    stroke: "#413AC5",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter25_d_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9967 73.0723V91.3223",
    stroke: "#413AC5",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.1295 19.624C10.1295 17.2652 12.4154 15.5818 14.668 16.2816L53.2599 28.2718C54.9113 28.7848 55.2176 31.0667 53.7918 32.0452C48.5207 35.6624 38.4775 43.178 28.8717 53.8223C17.8962 65.9843 10.1295 98.8223 10.1295 98.8223V19.624Z",
    fill: "url(#logo-developers_svg__paint24_linear_10099_8268)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5402,
    cy: 40.7788,
    r: 1.9565,
    fill: "url(#logo-developers_svg__paint25_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-developers_svg__mask5_10099_8268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 38,
    width: 5,
    height: 5
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5401,
    cy: 40.7788,
    r: 1.9565,
    fill: "url(#logo-developers_svg__paint26_linear_10099_8268)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-developers_svg__mask5_10099_8268)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter26_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9183 41.54C17.2704 42.198 17.3483 40.1445 16.7373 39.5429C16.1263 38.9413 15.0577 40.0193 15.7056 39.3613C16.3535 38.7033 17.374 38.6576 17.985 39.2593C18.596 39.8609 18.5662 40.882 17.9183 41.54Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter27_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7722 39.6072C18.5507 40.3289 16.3223 40.166 15.735 40.7995C15.1477 41.4331 16.4238 42.6231 15.6454 41.9014C14.8669 41.1798 14.7119 40.0812 15.2993 39.4476C15.8866 38.8141 16.9937 38.8856 17.7722 39.6072Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter28_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8915 41.8142C14.9415 41.4344 16.0706 42.2184 16.8205 42.3172C17.5704 42.416 17.6572 41.7922 17.6071 42.1721C17.5571 42.5519 16.9086 42.7798 16.1587 42.6809C15.4088 42.5821 14.8414 42.1941 14.8915 41.8142Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter29_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6631 41.3177C17.5581 42.3423 16.8376 40.5665 16.2848 40.5099C15.7319 40.4532 15.556 42.137 15.661 41.1125C15.7661 40.0879 16.2994 39.3033 16.8522 39.3599C17.4051 39.4166 17.7681 40.2931 17.6631 41.3177Z",
    fill: "#91EEFF"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7556 38.9889C16.1178 38.9061 14.8355 39.1908 14.8088 40.9928C14.9304 40.3886 15.4901 39.1419 16.7556 38.9889Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5402,
    cy: 76.7788,
    r: 1.9565,
    fill: "url(#logo-developers_svg__paint27_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-developers_svg__mask6_10099_8268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 74,
    width: 5,
    height: 5
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5401,
    cy: 76.7788,
    r: 1.9565,
    fill: "url(#logo-developers_svg__paint28_linear_10099_8268)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-developers_svg__mask6_10099_8268)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter30_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9183 77.54C22.2704 78.198 22.3483 76.1445 21.7373 75.5429C21.1263 74.9413 20.0577 76.0193 20.7056 75.3613C21.3535 74.7033 22.374 74.6576 22.985 75.2593C23.596 75.8609 23.5662 76.882 22.9183 77.54Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter31_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7722 75.6072C23.5507 76.3289 21.3223 76.166 20.735 76.7995C20.1477 77.4331 21.4238 78.6231 20.6454 77.9014C19.8669 77.1798 19.7119 76.0812 20.2993 75.4476C20.8866 74.8141 21.9937 74.8856 22.7722 75.6072Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter32_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8915 77.8142C19.9415 77.4344 21.0706 78.2184 21.8205 78.3172C22.5704 78.416 22.6572 77.7922 22.6071 78.1721C22.5571 78.5519 21.9086 78.7798 21.1587 78.6809C20.4088 78.5821 19.8414 78.1941 19.8915 77.8142Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter33_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6631 77.3177C22.5581 78.3423 21.8376 76.5665 21.2848 76.5099C20.7319 76.4532 20.556 78.137 20.661 77.1125C20.7661 76.0879 21.2994 75.3033 21.8522 75.3599C22.4051 75.4166 22.7681 76.2931 22.6631 77.3177Z",
    fill: "#91EEFF"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7556 74.9889C21.1178 74.9061 19.8355 75.1908 19.8088 76.9928C19.9304 76.3886 20.4901 75.1419 21.7556 74.9889Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5402,
    cy: 86.7788,
    r: 1.9565,
    fill: "url(#logo-developers_svg__paint29_linear_10099_8268)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-developers_svg__mask7_10099_8268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 84,
    width: 5,
    height: 5
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5401,
    cy: 86.7788,
    r: 1.9565,
    fill: "url(#logo-developers_svg__paint30_linear_10099_8268)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-developers_svg__mask7_10099_8268)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter34_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9183 87.54C27.2704 88.198 27.3483 86.1445 26.7373 85.5429C26.1263 84.9413 25.0577 86.0193 25.7056 85.3613C26.3535 84.7033 27.374 84.6576 27.985 85.2593C28.596 85.8609 28.5662 86.882 27.9183 87.54Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter35_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7722 85.6072C28.5507 86.3289 26.3223 86.166 25.735 86.7995C25.1477 87.4331 26.4238 88.6231 25.6454 87.9014C24.8669 87.1798 24.7119 86.0812 25.2993 85.4476C25.8866 84.8141 26.9937 84.8856 27.7722 85.6072Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter36_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8915 87.8142C24.9415 87.4344 26.0706 88.2184 26.8205 88.3172C27.5704 88.416 27.6572 87.7922 27.6071 88.1721C27.5571 88.5519 26.9086 88.7798 26.1587 88.6809C25.4088 88.5821 24.8414 88.1941 24.8915 87.8142Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-developers_svg__filter37_f_10099_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6631 87.3177C27.5581 88.3423 26.8376 86.5665 26.2848 86.5099C25.7319 86.4532 25.556 88.137 25.661 87.1125C25.7661 86.0879 26.2994 85.3033 26.8522 85.3599C27.4051 85.4166 27.7681 86.2931 27.6631 87.3177Z",
    fill: "#91EEFF"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7556 84.9889C26.1178 84.9061 24.8355 85.1908 24.8088 86.9928C24.9304 86.3886 25.4901 85.1419 26.7556 84.9889Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter0_f_10099_8268",
    x: -2.53861,
    y: -2.41227,
    width: 25.6571,
    height: 12.0609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.722735,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter1_f_10099_8268",
    x: 12.3678,
    y: 2.82748,
    width: 25.6571,
    height: 12.0609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.722735,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter2_f_10099_8268",
    x: 29.0359,
    y: 8.38363,
    width: 10.1182,
    height: 70.1956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.722735,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter3_i_10099_8268",
    x: -0.00305176,
    y: 1.28223,
    width: 34.8933,
    height: 73.9399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.21682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter4_f_10099_8268",
    x: 48.6648,
    y: 16.327,
    width: 13.5413,
    height: 6.36513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.381444,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter5_f_10099_8268",
    x: 56.5322,
    y: 19.0926,
    width: 13.5413,
    height: 6.36513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.381444,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter6_f_10099_8268",
    x: 65.3292,
    y: 22.0247,
    width: 5.34023,
    height: 37.0477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.381444,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter7_i_10099_8268",
    x: 50.0031,
    y: 18.2769,
    width: 18.416,
    height: 39.0234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.114433
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter8_f_10099_8268",
    x: 50.2343,
    y: 58.9222,
    width: 11.1336,
    height: 5.39541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.381444,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter9_f_10099_8268",
    x: 56.5252,
    y: 61.1331,
    width: 11.1336,
    height: 5.39541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.381444,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter10_f_10099_8268",
    x: 63.5594,
    y: 63.4778,
    width: 4.57583,
    height: 29.9296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.381444,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter11_i_10099_8268",
    x: 51.4574,
    y: 60.73,
    width: 14.7256,
    height: 30.9976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.114433
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter12_f_10099_8268",
    x: 6.1842,
    y: 9.75977,
    width: 35.5,
    height: 16.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter13_f_10099_8268",
    x: 26.8092,
    y: 17.0098,
    width: 35.5,
    height: 16.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter14_f_10099_8268",
    x: 49.8717,
    y: 24.6973,
    width: 14,
    height: 97.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter15_i_10099_8268",
    x: 9.69226,
    y: 14.8716,
    width: 48.2795,
    height: 102.305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter16_f_10099_8268",
    x: 10.1674,
    y: 40.8965,
    width: 50.2899,
    height: 78.4819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter17_f_10099_8268",
    x: 36.105,
    y: 52.9141,
    width: 9.65027,
    height: 11.0454,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter18_f_10099_8268",
    x: 23.0562,
    y: 54.1855,
    width: 19.9602,
    height: 20.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter19_f_10099_8268",
    x: 30.2929,
    y: 53.1399,
    width: 13.4477,
    height: 13.1611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.98913,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter20_f_10099_8268",
    x: 28.4689,
    y: 53.7224,
    width: 13.6817,
    height: 14.0669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.98913,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter21_f_10099_8268",
    x: 28.292,
    y: 62.4827,
    width: 12.8298,
    height: 7.18406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.98913,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter22_f_10099_8268",
    x: 26.4696,
    y: 50.5922,
    width: 19.0942,
    height: 19.8396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1087,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter23_dddd_10099_8268",
    x: 15.7467,
    y: 33.3223,
    width: 0.7,
    height: 53.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10099_8268"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10099_8268",
    result: "effect2_dropShadow_10099_8268"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_10099_8268",
    result: "effect3_dropShadow_10099_8268"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_10099_8268",
    result: "effect4_dropShadow_10099_8268"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_10099_8268",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter24_d_10099_8268",
    x: 20.7467,
    y: 60.3223,
    width: 0.7,
    height: 28.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10099_8268"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10099_8268",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter25_d_10099_8268",
    x: 25.7467,
    y: 72.8223,
    width: 0.7,
    height: 18.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10099_8268"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10099_8268",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter26_f_10099_8268",
    x: 14.8953,
    y: 38.2277,
    width: 4.13779,
    height: 4.04941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter27_f_10099_8268",
    x: 14.3343,
    y: 38.4069,
    width: 4.20969,
    height: 4.32822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter28_f_10099_8268",
    x: 14.2797,
    y: 41.1022,
    width: 3.9476,
    height: 2.21054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter29_f_10099_8268",
    x: 13.7192,
    y: 37.4439,
    width: 5.875,
    height: 6.10437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.956512,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter30_f_10099_8268",
    x: 19.8953,
    y: 74.2277,
    width: 4.13779,
    height: 4.04941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter31_f_10099_8268",
    x: 19.3343,
    y: 74.4069,
    width: 4.20969,
    height: 4.32822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter32_f_10099_8268",
    x: 19.2797,
    y: 77.1022,
    width: 3.9476,
    height: 2.21054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter33_f_10099_8268",
    x: 18.7192,
    y: 73.4439,
    width: 5.875,
    height: 6.10437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.956512,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter34_f_10099_8268",
    x: 24.8953,
    y: 84.2277,
    width: 4.13779,
    height: 4.04941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter35_f_10099_8268",
    x: 24.3343,
    y: 84.4069,
    width: 4.20969,
    height: 4.32822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter36_f_10099_8268",
    x: 24.2797,
    y: 87.1022,
    width: 3.9476,
    height: 2.21054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.304345,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-developers_svg__filter37_f_10099_8268",
    x: 23.7192,
    y: 83.4439,
    width: 5.875,
    height: 6.10437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.956512,
    result: "effect1_foregroundBlur_10099_8268"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint0_linear_10099_8268",
    x1: 3.1981,
    y1: 0.975552,
    x2: 17.8335,
    y2: 5.67333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68F0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28C8D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint1_linear_10099_8268",
    x1: 18.1045,
    y1: 6.2153,
    x2: 32.7398,
    y2: 10.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FD4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CE8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint2_linear_10099_8268",
    x1: 34.095,
    y1: 9.8291,
    x2: 34.095,
    y2: 77.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181D7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint3_linear_10099_8268",
    x1: 17.4436,
    y1: 0.378906,
    x2: 17.4436,
    y2: 76.2657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55E8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint4_linear_10099_8268",
    x1: 6.22456,
    y1: -15.557,
    x2: 5.77285,
    y2: 53.8255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0266745,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint5_linear_10099_8268",
    x1: 51.6926,
    y1: 18.115,
    x2: 59.4168,
    y2: 20.5944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68F0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28C8D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint6_linear_10099_8268",
    x1: 59.5599,
    y1: 20.8806,
    x2: 67.2841,
    y2: 23.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FD4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CE8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint7_linear_10099_8268",
    x1: 67.9993,
    y1: 22.7876,
    x2: 67.9993,
    y2: 58.3096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181D7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint8_linear_10099_8268",
    x1: 59.211,
    y1: 17.7998,
    x2: 59.211,
    y2: 57.8513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55E8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint9_linear_10099_8268",
    x1: 53.2898,
    y1: 9.38898,
    x2: 53.0514,
    y2: 46.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0266745,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint10_linear_10099_8268",
    x1: 52.8082,
    y1: 60.5048,
    x2: 58.9846,
    y2: 62.4873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68F0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28C8D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint11_linear_10099_8268",
    x1: 59.0991,
    y1: 62.7157,
    x2: 65.2755,
    y2: 64.6983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FD4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CE8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint12_linear_10099_8268",
    x1: 65.8473,
    y1: 64.2407,
    x2: 65.8473,
    y2: 92.6445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181D7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint13_linear_10099_8268",
    x1: 58.8202,
    y1: 60.2529,
    x2: 58.8202,
    y2: 92.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55E8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint14_linear_10099_8268",
    x1: 54.0855,
    y1: 53.5278,
    x2: 53.8949,
    y2: 82.8085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0266745,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint15_linear_10099_8268",
    x1: 14.1217,
    y1: 14.4473,
    x2: 34.3717,
    y2: 20.9473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68F0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28C8D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint16_linear_10099_8268",
    x1: 34.7467,
    y1: 21.6973,
    x2: 54.9967,
    y2: 28.1973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FD4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CE8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint17_linear_10099_8268",
    x1: 56.8717,
    y1: 26.6973,
    x2: 56.8717,
    y2: 119.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181D7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint18_linear_10099_8268",
    x1: 33.832,
    y1: 13.6216,
    x2: 33.832,
    y2: 118.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55E8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint19_linear_10099_8268",
    x1: 35.3123,
    y1: 51.6465,
    x2: 35.3123,
    y2: 108.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#471CA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint20_linear_10099_8268",
    x1: 38.7914,
    y1: 45.1787,
    x2: 38.7914,
    y2: 90.7161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33CFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288632,
    stopColor: "#2F8DC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991352,
    stopColor: "#8BF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint21_linear_10099_8268",
    x1: 42.9999,
    y1: 54.666,
    x2: 44.903,
    y2: 58.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint22_linear_10099_8268",
    x1: 35.6381,
    y1: 55.0723,
    x2: 35.6381,
    y2: 67.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint23_linear_10099_8268",
    x1: 35.6379,
    y1: 55.0723,
    x2: 35.6379,
    y2: 67.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint24_linear_10099_8268",
    x1: 18.309,
    y1: -8.42773,
    x2: 17.684,
    y2: 87.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0266745,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint25_linear_10099_8268",
    x1: 16.5402,
    y1: 38.8223,
    x2: 16.5402,
    y2: 42.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint26_linear_10099_8268",
    x1: 16.5401,
    y1: 38.8223,
    x2: 16.5401,
    y2: 42.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint27_linear_10099_8268",
    x1: 21.5402,
    y1: 74.8223,
    x2: 21.5402,
    y2: 78.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint28_linear_10099_8268",
    x1: 21.5401,
    y1: 74.8223,
    x2: 21.5401,
    y2: 78.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint29_linear_10099_8268",
    x1: 26.5402,
    y1: 84.8223,
    x2: 26.5402,
    y2: 88.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-developers_svg__paint30_linear_10099_8268",
    x1: 26.5401,
    y1: 84.8223,
    x2: 26.5401,
    y2: 88.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoDevelopers);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "static/logo-developers.df35f8a4.svg";